import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-cy": "wing-toppings"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_radiolist = _resolveComponent("radiolist")!
  const _component_dynamicSkeleText = _resolveComponent("dynamicSkeleText")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_radioGroup = _resolveComponent("radioGroup")!

  return (_ctx.hasAvailableFlavors)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ion_card_title, { class: "mx-8 mb-8 ion-text-center bold" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString('Choose Your ' + (_ctx.initialItem?.isAppetizer ? 'Sauce Cup' : 'Flavor')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", null, [
          (!_ctx.isCartLoader || _ctx.isLoader)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_radiolist, {
                  key: "SauceOrFlavor",
                  options: _ctx.availableTopping?.flavors,
                  keyName: "name",
                  dense: "",
                  modelValue: _ctx.localFlavor,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localFlavor) = $event)),
                  "data-cy": "choose-flavor"
                }, null, 8, ["options", "modelValue"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_dynamicSkeleText, {
                  element: "div",
                  childElements: [{ width: 60, height: '24px', class: 'mx-a mb-8' }]
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({ length: 4 }, (_, i) => i + 1), (i) => {
                  return (_openBlock(), _createBlock(_component_dynamicSkeleText, {
                    key: i,
                    element: "div",
                    childElements: _ctx.skeleText
                  }, null, 8, ["childElements"]))
                }), 128))
              ]))
        ]),
        (_ctx.hasAvailableDressings)
          ? (_openBlock(), _createBlock(_component_ion_item_divider, {
              key: 0,
              class: "my-8"
            }))
          : _createCommentVNode("", true),
        (_ctx.hasAvailableDressings)
          ? (_openBlock(), _createBlock(_component_ion_card_title, {
              key: 1,
              class: "mx-8 mb-8 ion-text-center bold"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Sauce Cup?")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          (!_ctx.isCartLoader || _ctx.isLoader)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_radioGroup, {
                  dense: "",
                  forceReselect: "",
                  key: "SauceCup",
                  keyName: "name",
                  componentKey: "SauceCup",
                  modelValue: _ctx.dressing1,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dressing1) = $event)),
                  options: _ctx.availableTopping?.dressings
                }, null, 8, ["modelValue", "options"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_dynamicSkeleText, {
                  element: "div",
                  childElements: [{ width: 60, height: '24px', class: 'mx-a mb-8' }]
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({ length: 4 }, (_, i) => i + 1), (i) => {
                  return (_openBlock(), _createBlock(_component_dynamicSkeleText, {
                    key: i,
                    element: "div",
                    childElements: _ctx.skeleText
                  }, null, 8, ["childElements"]))
                }), 128))
              ]))
        ]),
        (_ctx.selectedSize?.isPartySize && !_ctx.initialItem?.isAppetizer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_ion_card_title, { class: "mx-8 mb-8 ion-text-center bold" }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("Second Sauce Cup?")
                ])),
                _: 1
              }),
              _createElementVNode("div", null, [
                (!_ctx.isCartLoader || _ctx.isLoader)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_radioGroup, {
                        dense: "",
                        forceReselect: "",
                        keyName: "name",
                        key: "SecondSauceCup",
                        componentKey: "SecondSauceCup",
                        modelValue: _ctx.dressing2,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dressing2) = $event)),
                        options: _ctx.availableTopping?.dressings
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_dynamicSkeleText, {
                        element: "div",
                        childElements: [{ width: 60, height: '24px', class: 'mx-a mb-8' }]
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({ length: 4 }, (_, i) => i + 1), (i) => {
                        return (_openBlock(), _createBlock(_component_dynamicSkeleText, {
                          key: i,
                          element: "div",
                          childElements: _ctx.skeleText
                        }, null, 8, ["childElements"]))
                      }), 128))
                    ]))
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}